export const videos = [

    // ===========================
    // 2026
    // ===========================

    {  
        year: 2026,
        category: "",
        title: "Fiesta de la Chilenidad",
        url: "https://www.youtube.com/watch?v=wrljTVodIsg"
    }, 


    
    {  
        year: 2026,
        category: "",
        title: "Desfile Banda de Guerra",
        url: "https://www.youtube.com/watch?v=wejpuYYMcEc"
    },


    {  
        year: 2026,
        category: "",
        title: "Inauguración Punto de Reciclaje",
        url: "https://www.youtube.com/watch?v=Lja49DtwAAo"
    },

    
    {
        year: 2026,
        category: "",
        title: "Inauguración Sala Sensorial",
        url: "https://www.youtube.com/watch?v=nQ9eay_NHa8"
    },




    {
        year: 2026,
        category: "Ley 21.827",
        title: "Ley 21.827 Escuelas Protegidas",
        url: "https://www.youtube.com/watch?v=L_3FR0Pl5O4"
    },

    {
        year: 2026,
        category: "Literatura",
        title: "Encuentro Literario",
        url: "https://www.youtube.com/watch?v=nEzcclcapuQ"
    },

    {
        year: 2026,
        category: "Ceremonias",
        title: "Lanzamiento Año Escolar 2026",
        url: "https://www.youtube.com/watch?v=R27q6oEQxYY"
    },

    // ===========================
    // 2025
    // ===========================

    {
        year: 2025,
        category: "Ceremonias",
        title: "Graduación Kinder año 2025",
        url: "https://www.youtube.com/watch?v=5fO22OusTgQ"
    },

    {
        year: 2025,
        category: "Ceremonias",
        title: "Licenciatura 8° básico año 2025",
        url: "https://www.youtube.com/watch?v=2sEk2zg2VJo"
    },

    {
        year: 2025,
        category: "Ceremonias",
        title: "Despedida 8° básico año 2025",
        url: "https://www.youtube.com/watch?v=s3aUzK1cU5Y"
    },

    {
        year: 2025,
        category: "Lectura",
        title: "Ceremonia de la Lectura 2025",
        url: "https://www.youtube.com/watch?v=xm8Tsio22wY"
    },

    {
        year: 2025,
        category: "Ciencia",
        title: "Feria de las Ciencias, Tecnología y Medio Ambiente 2025",
        url: "https://www.youtube.com/watch?v=jUC4rb-tpUk"
    },

    {
        year: 2025,
        category: "Celebraciones",
        title: "Fiesta de la Chilenidad 2025",
        url: "https://www.youtube.com/watch?v=DC-eVlSNQsU"
    },

    {
        year: 2025,
        category: "Convivencia Escolar",
        title: "Año 2025 Contra la no Violencia",
        url: "https://www.youtube.com/watch?v=S9l7ucVcuII"
    },

    {
        year: 2025,
        category: "Aniversario",
        title: "Aniversario Escuela N° 59",
        url: "https://www.youtube.com/watch?v=DAgx7asFHvQ"
    },

    {
        year: 2025,
        category: "Historia",
        title: "El Baúl Mágico de la Historia de Chile",
        url: "https://www.youtube.com/watch?v=ueYxWpL6nz0"
    },

    {
        year: 2025,
        category: "Literatura",
        title: "VIII Café Literario",
        url: "https://www.youtube.com/watch?v=s_NRYNMNzHA"
    },

    // ===========================
    // 2024
    // ===========================

    {
        year: 2024,
        category: "Ceremonias",
        title: "Graduación Kinder año 2024",
        url: "https://www.youtube.com/watch?v=jDsZ8jZAfsU"
    },

    {
        year: 2024,
        category: "Ceremonias",
        title: "Licenciatura 8° Básico año 2024",
        url: "https://www.youtube.com/watch?v=BnS4Fa6105E"
    },

    {
        year: 2024,
        category: "Ciencia",
        title: "Feria de la Ciencia, Tecnología y Medio Ambiente 2024",
        url: "https://www.youtube.com/watch?v=7QJ9nNyzDik"
    },

    {
        year: 2024,
        category: "Interculturalidad",
        title: "Encuentro Intercultural 2024",
        url: "https://www.youtube.com/watch?v=oZd220nOlZc"
    },

    {
        year: 2024,
        category: "Talleres",
        title: "Talleres JEC 2024",
        url: "https://www.youtube.com/watch?v=GK8Yx8Mo0Bc"
    },

    {
        year: 2024,
        category: "Literatura",
        title: "VII Café Literario 2024",
        url: "https://youtu.be/PsZhROrJq7o"
    },

    // ===========================
    // 2023
    // ===========================

    {
        year: 2023,
        category: "Innovación",
        title: "Reportaje Planta Fotovoltaica",
        url: "https://www.youtube.com/watch?v=5pOC58xCiCA"
    },

    {
        year: 2023,
        category: "Ceremonias",
        title: "Licenciatura 8° Básico Año 2023",
        url: "https://www.youtube.com/watch?v=YbhDZBxGG54"
    },

    {
        year: 2023,
        category: "Ceremonias",
        title: "Graduación Kinder Año 2023",
        url: "https://www.youtube.com/watch?v=yCmkUQ3jT0U"
    },

    {
        year: 2023,
        category: "Ciencia",
        title: "III Feria de las Ciencias",
        url: "https://www.youtube.com/watch?v=soADQotU_5c"
    },

    {
        year: 2023,
        category: "Literatura",
        title: "VI Café Literario Año 2023",
        url: "https://www.youtube.com/watch?v=XWl5j7wZv84"
    },

    {
        year: 2023,
        category: "Interculturalidad",
        title: "Encuentro Intercultural Año 2023",
        url: "https://www.youtube.com/watch?v=nI3z7kTbsnU"
    },

    {
        year: 2023,
        category: "Aniversario",
        title: "Aniversario Escuela N° 57",
        url: "https://www.youtube.com/watch?v=kZ7IkDY5EZk"
    },

    // ===========================
    // 2022
    // ===========================

    {
        year: 2022,
        category: "Ceremonias",
        title: "Licenciatura 8° Básico Año 2022",
        url: "https://www.youtube.com/watch?v=9vmXY_KUhH8"
    },

    {
        year: 2022,
        category: "Ceremonias",
        title: "Graduación Kinder Año 2022",
        url: "https://www.youtube.com/watch?v=_ZOAevMy7yo"
    },

    {
        year: 2022,
        category: "Medio Ambiente",
        title: "Feria Medio Ambiental Año 2022",
        url: "https://www.youtube.com/watch?v=2CWUrNVx6S0"
    },

    {
        year: 2022,
        category: "Aniversario",
        title: "Aniversario Escuela N° 56",
        url: "https://www.youtube.com/watch?v=ERLCunHe9dA"
    },

    // ===========================
    // 2021
    // ===========================

    {
        year: 2021,
        category: "Ceremonias",
        title: "Graduación 8° Básico Año 2021",
        url: "https://www.youtube.com/watch?v=WO2jWBJ7e5M"
    },


    {
        year: 2021,
        category: "Ceremonias",
        title: "Graduación Kinder Año 2021",
        url: "https://www.youtube.com/watch?v=bpl3TphHOfQ"
    },

    {
        year: 2021,
        category: "Celebraciones",
        title: "Fiestas Patrias 2021",
        url: "https://www.youtube.com/watch?v=42zBH9n1FKM"
    },

    {
        year: 2021,
        category: "Ciencia",
        title: "Feria Científica Año 2021",
        url: "https://www.youtube.com/watch?v=MzQF0RNg4Jk"
    },

    // ===========================
    // 2020
    // ===========================

    {
        year: 2020,
        category: "Ceremonias",
        title: "Licenciatura 8° Básico Año 2020",
        url: "https://www.youtube.com/watch?v=upRUqHt44Zc"
    },

    // ===========================
    // 2017
    // ===========================

    {
        year: 2017,
        category: "Literatura",
        title: "Tercer Café Literario Año 2017",
        url: "https://www.youtube.com/watch?v=n4S4_qOkFhA"
    },

    // ===========================
    // 2016
    // ===========================

    {
        year: 2016,
        category: "Literatura",
        title: "Segundo Café Literario Año 2016",
        url: "https://www.youtube.com/watch?v=_naNticc0Yg"
    }

];